export enum PublishState {
	not_started = "not-started",
	in_progress = "in-progress",
	success = "success",
	error = "error",
}
